export const TRIAL_EXPIRED_MODAL_ID = 'trial-expired-modal';
export const UPGRADE_ACCESS_MODAL_ID = 'upgrade-access-modal';
// Chat-specific upgrade prompt. Separate from UPGRADE_ACCESS so the free-tier
// chat quota can speak to the limit that was actually hit; the modals registry
// is keyed by id only and carries no per-open props.
export const CHAT_LIMIT_MODAL_ID = 'chat-limit-modal';
